import { Request, Response } from '@jfs/network'
import { isEmpty } from '@jfs/ui-new/src/utils/utils'
import { RootStore } from '../data/store'
import { AESEncrypt, generateRandomString, RSAEncrypt } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { appSessionRefreshConfig, BASE_URL } from './config'

const responseParser = (response: any) => ({
  appIdToken: response?.session?.appIdentifierToken,
  appRefreshToken: response?.session?.refreshToken?.tokenValue,
  appAccessToken: response?.session?.accessToken?.tokenValue,
  appAccessTokenExpiry: response?.session?.accessToken?.expiresIn,
  appRefreshTokenExpiry: response?.session?.refreshToken?.expiresIn,
})

export const extendAppSession = (accessToken: string, refreshToken: string, clientId: string, CHANNEL_ID: string) => {
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)
  let token = AESEncrypt(randomEncryptionKey, accessToken)
  let refToken = AESEncrypt(randomEncryptionKey, refreshToken)

  console.log(responseParser, 'responseParser::', extendAppSession)

  const request: Request<{}> = {
    apiPath: `${BASE_URL}${APIEndPoints.appAuth}`,
    method: 'POST',
    headers: appSessionRefreshConfig(CHANNEL_ID).headers,
    body: {
      application: {
        clientId,
      },
      authenticateList: [
        {
          mode: 14,
          accessToken: token,
          refreshToken: refToken,
        },
      ],
      scope: 'SESSION',
      purpose: 1,
      secure: {
        encryptionKey: encryptedKey ?? '',
      },
    },
  }
  return request
}

export const AppHeaderTransformer = async (response: Response, originalRequest?: Request<any>) => {
  if (response) {
    const { data } = response
    if (
      !isEmpty(data?.session?.accessToken?.tokenValue) &&
      !isEmpty(data?.session?.refreshToken?.tokenValue) &&
      !isEmpty(data?.session?.appIdentifierToken)
    ) {
      const appSessionData = responseParser(data)

      if (
        appSessionData &&
        originalRequest &&
        appSessionData.appAccessToken &&
        appSessionData.appIdToken &&
        originalRequest.headers
      ) {
        originalRequest.headers = {
          ...originalRequest.headers,
          'x-app-access-token': appSessionData.appAccessToken,
          'x-trace-id': generateRandomString(16),
          'x-appid-token': appSessionData.appIdToken,
        }
      }
      await RootStore?.agent?.session?.updateAppSessionData(appSessionData)
    } else {
      // RootStore.session.updateAppSessionData('', '', -1, -1, '')
      await RootStore?.agent?.session?.logout()
      await RootStore.message.showErrDialog('App session expired. Please re-login', 'CLOSE_WEBVIEW')
    }
  }
}
